{
  "add": "Toevoegen",
  "add-barn-first-description": "Voeg eerst stallen toe aan uw profiel. Hierna kunt u hier de aanvoer registreren.",
  "add-cycle": "Ronde toevoegen",
  "add-day-old-chick-first-description": "Voeg eerst aanvoer toe. Hierna kunt u hier de afvoer registreren.",
  "age": "Leeftijd",
  "amount": "Aantal",
  "app": {
    "cycles": "Rondes",
    "deliveries": "Leveringen",
    "reports": "Rapporten",
    "settings": "Instellingen",
    "products": "Producten",
    "farmer-insights": "Farmer Insights",
    "advices": "Adviezen",
    "feed-advice": "Voeradvies",
    "reference-value-sheet": "Normkaart",
    "standard-reference-value-sheet": "Standaard Normkaarten",
    "reference-scheme": "Standaard Voeradviezen",
    "management": "Beheer",
    "performance": "Prestaties",
    "within-cycle-performance": "Prestaties gedurende ronde"
  },
  "farmer-insights": {
    "kpiGroups": {
      "TechnicalPerformance": "Technische resultaten",
      "FinancialPerformance": "Financiële resultaten",
      "ArrivalAndDeparture": "Opgezet en afgeleverd",
      "FeedConsumption": "Voerverbruik",
      "WellBeing": "Welzijn",
      "RevenueAndCost": "Kosten en opbrengsten"
    },
    "description": "Realtime inzicht in uw data!",
    "locations": "Locaties",
    "location": "Locatie",
    "cycles": "Rondes",
    "barns": "Stallen",
    "detail-level": "Detailniveau",
    "display-type": "Weergave",
    "kpis-name": "KPI's",
    "table": "Tabel",
    "chart": "Grafiek",
    "kpi-selection": "KPI selectie",
    "aggregation": {
      "Sum": "Cumulatief",
      "Average": "Gemiddeld",
      "Min": "Min",
      "Max": "Max"
    },
    "custom-footers": {
      "end-total": "Eindtotaal",
      "same-period": "<Tenant> geselecteerde periode (koppels:",
      "last-weeks": "<Tenant> laatste 10 weken (koppels:",
      "customer-average-selected-period": "Klant gemiddelde geselecteerde periode (koppels:"
    },
    "no-data": {
      "title": "Er zijn nog geen Insights beschikbaar",
      "description": "De Insights worden getoond, zodra er een of meerdere koppels zijn aangemaakt."
    },
    "no-benchmark": "Onvoldoende data beschikbaar (minimaal 15 koppels nodig).",
    "benchmark-title": "<Tenant>",
    "benchmark-selected-period": "geselecteerde periode",
    "benchmark-last-weeks": "laatste 10 weken",
    "norm": "norm",
    "benchmark-settings": "Benchmark instellingen",
    "settings": {
      "header": "Filters",
      "title": "Benchmark instellingen",
      "subtitle": "Hier kunt u instellen met welke benchmark u uw koppels wilt vergelijken als u niet op de modus 'gedetailleerd' staat",
      "selected-period-label": "<Tenant> benchmark voor geselecteerde periode weergeven",
      "last-weeks-label": "<Tenant> benchmark laatste 10 weken weergeven",
      "customer-average-selected-period-label": "Klant gemiddelde voor geselecteerde periode weergeven",
      "none": "Geen",
      "select-multiple-benchmark-label": "U kunt meerdere benchmarks selecteren",
      "select-one-benchmark-label": "U kunt maximaal één benchmark selecteren",
      "non-detailed-view-label": "Niet-gedetailleerde weergaves",
      "detailed-view-label": "Gedetailleerde weergaves"
    },
    "reset-filters": "Herstel KPI selectie",
    "to": "tot",
    "maxPrintWarning": {
      "title": "Waarschuwing",
      "message": "Er zijn meer KPI's geselecteerd dan mogelijk is om te printen op één pagina. Allen het eerst aantal mogelijke KPI kolommen kunnen worden geprint. Aantal KPI's mogelijk om te printen op dit moment:"
    },
    "kpis": {
      "DayOldChicks": "Aanvoer Aantal",
      "DayOldChicksPrice": "Aanvoer Bedrag",
      "TotalDeparture": "Totale Afvoer Aantal",
      "DepartureWeight": "Afgeleverd Gewicht",
      "SlaughterWeight": "Slacht Gewicht",
      "Revenue": "Uitbetaald Bedrag",
      "FeedBalance": "Voerverbruik",
      "FeedBalancePrice": "Voerverbruik Bedrag",
      "LossPercentage": "Uitvalpercentage",
      "ReplacementPercentage": "Vervangingspercentage",
      "FeedConversion": "Voerconversie",
      "FeedConversion1500": "Voerconversie 1500",
      "AverageWeightInGram": "Gemiddeld Gewicht",
      "WeightedAverageAgeInDays": "Gemiddelde Gewogen Leeftijd",
      "WeightedAverageGrowthPerDay": "Groei",
      "ProductionNumber": "Productiegetal",
      "DayOldChicksPerSquareMeter": "Aanvoer Aantal per m²",
      "FeedUsageInKgPerSquareMeter": "Voerverbruik per m²",
      "FeedConsumptionPricePer100Kg": "Voerverbruik Bedrag per 100 kg",
      "PaidAmountPerKg": "Uitbetaald Bedrag per kg",
      "NettoRevenue": "Voerwinst Bedrag",
      "NettoRevenuePerChick": "Voerwinst Bedrag per kuiken",
      "NettoRevenuePerSquareMeterPerDay": "Voerwinst Bedrag per m² per dag",
      "RejectionRate": "Afkeur doorberekend",
      "PricePerDayOldChick": "Aanvoer bedrag per kuiken",
      "FeedBalanceMixProduct": "Voerverbruik Mengvoer",
      "FeedBalanceRawProduct": "Voerverbruik Enkelvoudig",
      "DeliveredKgPerSquareMeter": "Geleverde kg per m²",
      "NettoRevenuePerSquareMeter": "Voerwinst Bedrag per m²",
      "FeedConsumptionPerDeliveredKg": "Voerkosten per afgeleverde kg",
      "DayOldChicksWeight": "Aanvoer Gewicht",
      "WeightedHeelDermatitis": "Gewogen Hakdermatitis",
      "WeightedFootpadLesionNonePercentage": "Gewogen VZL 0",
      "WeightedFootpadLesionModeratePercentage": "Gewogen VZL 1",
      "WeightedFootpadLesionSeverePercentage": "Gewogen VZL 2",
      "TotalLoss": "Uitval aantal",
      "WeightedFootpadLesionScore": "Gewogen VZL Score",
      "FeedBalanceRawPrice": "Voerverbruik Enkelvoudig Bedrag",
      "FeedBalanceMixPrice": "Voerverbruik Mengvoer Bedrag",
      "PartialDeparture": "Afvoer Uitladers Aantal",
      "FullDeparture": "Afvoer Wegladers Aantal",
      "NettoProfitInclOtherCosts": "Saldo",
      "DayOldChicksPriceExclDiscounts": "Voerverbruik Bedrag excl. kortingen",
      "RevenueExclDiscounts": "Uitbetaald Bedrag excl. kortingen",
      "FeedBalancePriceExclDiscounts": "Voerverbruik Bedrag excl. kortingen"
    },
    "data-view-types": {
      "PerLocation": "Per Locatie",
      "PerCycle": "Per Ronde",
      "PerCycleBarn": "Per Ronde Per Stal",
      "PerLocationBarn": "Per Stal"
    },
    "customer-average-selected-period": "Klant gemiddelde geselecteerde periode",
    "show-more": "toon meer",
    "show-less": "toon minder"
  },
  "within-cycle-performance": {
    "advice_and_reference-value-sheet": "Gekoppelde voeradvies & normkaart",
    "kpi": "KPI",
    "kpis": {
      "IndoorTemperature": "Temperatuur binnen",
      "IndoorHumidity": "Vochtigheid binnen",
      "MortalityPercentage": "Uitval%",
      "FeedIntakePerChick": "Voeropname (per dier)",
      "WaterIntakePerChick": "Wateropname (per dier)",
      "WeightGainPerChick": "Gewichtstoename (per dier)",
      "WaterToFeedRatio": "Water:voer verhouding",
      "FeedConversionRate": "Voerconversie",
      "LitterQuality": "Strooisel score",
      "LitterQualityCaked": "Dichtgeslagen",
      "LitterQualityLoose": "Rul",
      "LitterQualityWet": "Nat",
      "BodyWeight": "Gewicht",
      "GrowthPrediction": "Groei voorspelling",
      "IndoorOutdoorTemperature": "Temperatuur binnen / buiten",
      "IndoorOutdoorHumidity": "Vochtigheid binnen / buiten",
      "OutdoorTemperature": "Temperatuur buiten",
      "OutdoorHumidity": "Vochtigheid buiten"
    },
    "no-data": "Geen data beschikbaar."
  },
  "area": "Oppervlakte",
  "arrival-date": "Aanvoerdatum",
  "avined": "Avined",
  "balance": {
    "add-manual-delivery": "Toevoegen levering",
    "balance-row": "Balansregel",
    "barn-distribution": {
      "available-in-this-cycle": "Beschikbaar binnen deze ronde",
      "change-flock-allocation": "Wijzig koppelverdeling",
      "currently": "Momenteel:",
      "delivery-line-info": "Leverregel informatie",
      "flock-allocation": "Koppelverdeling",
      "kg-per-chick": "kg/POK",
      "of-which-remaining": "Waarvan restant",
      "total-should-be": "De totale verdeling moet uitkomen op",
      "totally-delivered": "Totaal geleverd",
      "usage-in-kg": "Verbruik (kg)",
      "usage-in-other-cycles": "Verbruik in andere rondes",
      "usage-in-this-cycle": "Verbruik binnen de ronde",
      "total": "Totaal",
      "totalRaw": "Totaal enkelvoudig voer",
      "totalCompound": "Totaal mengvoer"
    },
    "consumption": "Verbruik (kg)",
    "delivery-date": "Leverdatum",
    "empty-day-old-chick-description": "Voeg eerst aanvoer toe. Daarna kunt u hier de balansregels toevoegen.",
    "empty-day-old-chick-title": "Er is nog geen aanvoer",
    "empty-description": "Klik op 'Herberekenen' om de balans te tonen.",
    "empty-title": "Er zijn geen balansregels gevonden",
    "manual-add": "Handmatig",
    "multiple-deliveries": "Meerdere leveringen",
    "price": "Bedrag",
    "product": "Product",
    "quantity": "Hoeveelheid (kg)",
    "recalculate": "Herberekenen",
    "recalculate-warning": {
      "text": "Alle leveringen voor de huidige ronde worden opnieuw opgehaald. Eventuele nieuwe leveringen worden toegevoegd. Alle restanten worden op nul gezet.",
      "title": "Weet u zeker dat u wilt herberekenen?"
    },
    "remainder": "Restant (kg)",
    "remainder-greater-than-quantity": "Het restant kan niet groter zijn dan de hoeveelheid.",
    "remainder-less-than-zero": "Het restant kan niet kleiner zijn dan 0.",
    "remainder-less-than-quantity": "Het restant kan niet kleiner zijn dan de hoeveelheid.",
    "remainder-greater-than-zero": "Het restant kan niet groter zijn dan 0.",
    "remainder-other-than-zero": "Het restant kan niet anders zijn dan 0.",
    "remainder-NaN": "Het restant is geen valide getal.",
    "pending-changes-warning": {
      "title": "Onopgeslagen wijzingen",
      "message": "Let op, u heeft onopgeslagen wijzingen op de balans.",
      "confirmText": "Doorgaan zonder opslaan",
      "cancelText": "Op deze pagina blijven"
    },
    "save-confirm": {
      "title": "Opslaan balans",
      "text": "De balans is nog niet definitief gemaakt. Met opslaan en definitief maken, kunt u de balans de status “definitief” geven. Zolang de balans nog niet volledig is, kiest u voor “Opslaan”. Hiermee kunt u de balans opslaan met status “voorlopig”.",
      "alert": "De balans definitief maken is belangrijk, omdat de ronde dan pas als compleet zal worden aangemerkt in de rapporten."
    },
    "edit-confirm": {
      "title": "Wijzigen balans",
      "text": "Als u kiest voor balans wijzigen, zal de status van de balans wijzigen van “definitief” naar “voorlopig”. U kunt vervolgens uw wijzigingen doorvoeren en de balans opnieuw definitief maken.",
      "alert": "De balans na de wijzigingen opnieuw definitief maken is belangrijk, omdat een ronde met een voorlopige balans niet als compleet zal worden aangemerkt in de rapporten."
    },
    "not-finalized": {
      "title": "Balans nog niet definitief",
      "message": "De balans is nog niet definitief gemaakt. Met 'Opslaan en definitief maken' kunt u de balans direct definitief maken."
    },
    "save-and-finalize": "Opslaan en definitief maken",
    "save": "Opslaan",
    "edit": "Wijzigen",
    "edit-balance": "Balans wijzigen",
    "delete-confirm": {
      "text": "Dit zal de levering uit deze lijst verwijderen.",
      "title": "Weet je zeker dat je deze levering wilt verwijderen?"
    },
    "has-empty-barns": {
      "title": "Foutieve balansregels gevonden",
      "message": "Er zijn balansregels waarvoor geen stal wordt gevonden. Door de balans te herberekenen, wordt dit probleem opgelost."
    },
    "barn-name": "Stal",
    "invoice-date": "Factuurdatum",
    "invoice-number": "Factuurnummer",
    "delivery-number": "Levering ID"
  },
  "balance-item": {
    "add-product": "Handmatig invoeren",
    "error-product-selected": "Kies een product",
    "no-products": "Er zijn geen bestaande producten gevonden.",
    "product": "Product"
  },
  "balance-item-delivery": {
    "amount": "Hoeveelheid per stal",
    "current-usage": "Actueel verbruik",
    "error-amount": "Voer de hoeveelheid in",
    "error-no-amount": "Geef voor minimaal 1 stal de hoeveelheid op.",
    "remaining-of": "resterend van"
  },
  "balance-item-manual": {
    "amount": "Hoeveelheid per stal",
    "delivery-date": "Leverdatum",
    "error-amount": "Voer de hoeveelheid in",
    "error-delivery-date": "Voer de leverdatum in",
    "error-no-amount": "Geef voor minimaal 1 stal de hoeveelheid op.",
    "error-price": "Voer de netto prijs in",
    "error-product-title": "Voer de productomschrijving in",
    "error-supplier-name": "Voer de naam van de leverancier in",
    "error-vat": "Voer het BTW percentage in",
    "price": "Netto prijs, excl. BTW",
    "product-title": "Productomschrijving",
    "product-type-multiple": "Mengvoer",
    "supplier-name": "Leverancier",
    "vat": "BTW"
  },
  "balance-summary": {
    "consumption-per-delivered-chick": "Verbruik/afgeleverd kuiken",
    "final-stock": "Eindvoorraad (kg)",
    "initial-stock": "Beginvoorraad (kg)",
    "title": "Samenvatting balans",
    "total": "Totaal verbruik (kg)",
    "delivery-stock": "Levering (kg)",
    "product": "Product"
  },
  "barn": "Stal",
  "barn-item": {
    "area": "Oppervlakte",
    "error-name-duplicate": "Deze stalnaam is al in gebruik, voer een unieke stalnaam in",
    "error-name-required": "Voer de stalnaam in",
    "error-surface-area": "Voer het oppervlakte in",
    "name": "Stal omschrijving",
    "animal-group-barn-id": "Animal Group Stal ID",
    "not-mapped": "(Niet in kaart gebracht)"
  },
  "birth-date": "Geboortedatum",
  "breed": "Ras",
  "cadaver": "Kadavers",
  "catching": "Vangen/laden",
  "certification": "IKB",
  "chick-price": "Netto prijs per eendagskuiken, excl. BTW",
  "chickens": "Kippen",
  "chicks-parents-age-in-weeks": "Leeftijd Ouders",
  "chicks-weight-in-grams": "Gewicht kuikens",
  "close-round": "Ronde sluiten",
  "concept": "Concept",
  "costs": "Kosten",
  "costs-specification": "Kostenspecificatie",
  "couple": "Koppel",
  "couple-number": "Nr",
  "couples": "Koppels",
  "customer-id": "Klantnummer",
  "cycle": "Ronde",
  "cycle-navigation": {
    "balance": "Balans",
    "closure": "Sluiten",
    "day-old-chick": "Aanvoer",
    "departure": "Afvoer",
    "general": "Algemeen"
  },
  "cycle-number": "Nr.",
  "enter-amounts": "Bedragen invullen",
  "n/a": "n.v.t.",
  "cycle-overview": {
    "barn": "Stal",
    "consumption-empty": {
      "description": "Voeg voerverbruik toe om hier balansregels te zien.",
      "title": "Er zijn geen balansregels."
    },
    "daily-performance-empty": {
      "description": "Voeg Aanvoer toe om wekelijkse / dagelijkse prestaties beschikbaar te maken.",
      "title": "Invoer niet mogelijk."
    },
    "cycle": "Ronde",
    "delete-cycle": "Verwijderen",
    "edit-current-week": "Weekregistraties invoeren",
    "weekregistration-overview": "Weekregistraties Overzicht",
    "detailedOverview": "Gedetailleerd",
    "edit": "wijzig",
    "edit-cycle": "Wijzigen",
    "option-all-barn": "- alle stallen -",
    "panel": {
      "add-day-old-chick": "Aanvoer toevoegen",
      "add-departure": "Afvoer toevoegen",
      "amount": "Aantal",
      "balance-overview": "Balans overzicht",
      "balance-title": "Voerverbruik",
      "birthdate": "Geboortedatum",
      "consumption": "Verbruik (kg)",
      "consumption-per-chick": "Verbruik p.a.k. (g)",
      "date": "Aanvoer datum",
      "day-old-chick-overview": "Aanvoer overzicht",
      "day-old-chick-title": "Aanvoer Kuikens",
      "day-old-chick-total": "Totaal Aanvoer kuikens",
      "departure-overview": "Afvoer overzicht",
      "departure-title": "Afvoer Kuikens",
      "departure-total": "Totaal Afvoer kuikens",
      "departuredate": "Afvoerdatum",
      "departureweight": "Afvoer gewicht",
      "price": "Prijs",
      "price-ex-vat-per-chick": "Prijs per kuiken (excl. BTW)",
      "price-ex-vat": "Bedrag (excl. BTW)",
      "product-title": "Voernaam",
      "product-type-mixedproduct": "Mengvoer",
      "product-type-rawproduct": "Enkelvoudig",
      "revenue": "Opbrengst",
      "slaughterweight": "Uitbetaald gewicht",
      "type": "Type",
      "type-full": "Wegladers",
      "type-manual": "Handmatig",
      "type-partial": "Uitladers",
      "type-platform": "Platform",
      "type-start": "Platform",
      "total-consumption": "Totaal verbruik",
      "daily-performance-title": "Wekelijkse en Dagelijkse Observatie Registraties",
      "edit-current-week": "Weekregistraties invoeren",
      "cycle-title": "Ronde",
      "discount-title": "Kortingen",
      "discount-overview": "Kortingsoverzicht"
    },
    "placeholder": "- maak een selectie -",
    "start-new-cycle": "Nieuwe ronde starten",
    "weekregistration-download": "Sjabloon downloaden",
    "weekregistration-upload": "Importeer",
    "weekregistration-select-file": "Selecteer een bestand...",
    "weekregistration-upload-csv-title": "Selecteer een CSV-bestand om te importeren",
    "upload-csv-message": "Kolommen mogen niet uit de template worden verwijderd, ook niet als ze leeg zijn. Velden kunnen wel leeg worden gelaten.",
    "upload-csv-notification": "Selecteer een CSV-bestand om te importeren",
    "weekregistration-select-interval-type": "Intervaltype",
    "download-weekly-report": "Wekelijks verslag",
    "cycle-start-in-future-warning-description": "De startdatum van deze ronde ligt in de toekomst. Hierdoor is het niet mogelijk om observaties te registreren.",
    "cycle-start-in-future-warning-title": "Ronde nog niet gestart"
  },
  "wdo-labels": {
    "mortality": "Uitval",
    "feedIntake": "Voeropname",
    "waterIntake": "Wateropname",
    "indoorTemperature": "Binnentemperatuur (°C)",
    "outdoorTemperature": "Buitentemperatuur (°C)",
    "indoorHumidity": "Binnen luchtvochtigheid (%)",
    "outdoorHumidity": "Buiten luchtvochtigheid (%)",
    "weight": "Gewicht (g)",
    "litterQuality": "Strooisel score",
    "litterQualities": {
      "Loose": "Strooisel score rul (%)",
      "Caked": "Strooisel score dichtgeslagen (%)",
      "Wet": "Strooisel score nat (%)"
    },
    "selection": "Selectie",
    "selectionSmall": "Selectie kleine dieren",
    "selectionLegProblems": "Selectie poot problemen",
    "feedIntakeGramPerBird": "Voeropname (Gram per dier)",
    "feedIntakeKg": "Voeropname (Kg)",
    "waterIntakeMililiterPerBird": "Wateropname (Ml per dier)",
    "waterIntakeL": "Wateropname (L)",
    "kilogramSuffix": "Kg",
    "gramSuffix": "Gram",
    "literSuffix": "L",
    "mililiterSuffix": "Ml",
    "ageInDays": "Leeftijd in dagen"
  },
  "wdo-settings": {
    "title": "Wekelijkse en dagelijkse observatie instellingen",
    "disabled-message": "Deze instellingen kunnen niet meer worden gewijzigd omdat er inmiddels weekregistraties zijn opgevoerd.",
    "startday-description": "Hier stelt u in op welke weekdag de eerste week van de registratie start.",
    "startday-label": "Weekdag instelling",
    "startday-placeholder": "- selecteer een startdag -",
    "weekly-daily-description": "Hier bepaalt u welke gegevens u per dag of per week wilt invullen.",
    "open-settings": "Open instellingen",
    "general-option": {
      "label": "Algemene instelling",
      "per-day": "Per dag voor alle",
      "per-week": "Per week voor alle"
    },
    "setting-option": {
      "off": "Uit",
      "per-day": "Per dag",
      "per-week": "Per week"
    },
    "delete-confirm": {
      "title": "Weet je zeker dat je deze instellingen wilt wijzigen?",
      "text": "Dit zal de data voor de volgende KPI's verwijderen bij opslaan; "
    }
  },
  "wdo-registration": {
    "all-settings-are-off-title": "Alle registratievelden zijn uitgeschakeld.",
    "all-settings-are-off-message": "Ga eerst naar de Wekelijkse en dagelijkse observatie instellingen op de Algemeen-tab van de ronde en stel daar uw gewenste instellingen in.",
    "registration": "Wekelijkse en dagelijkse observatie registraties",
    "cycle-date": "Aanvoerdatum",
    "cycle-end-date": "Ronde einddatum",
    "select-week": "Week",
    "select-week-placeholder": "- selecteer een week -",
    "select-barn": "Stal",
    "select-barn-placeholder": "- selecteer een stal -",
    "validation-errors": {
      "total-must-be-100": "Het totaal van de strooisel score zou 100% moeten zijn.",
      "date-is-not-valid-title": "Onjuiste datums in uploadbestand",
      "date-is-not-valid-description": "Er zijn gegevens in het uploadbestand met een dag/week die groter/kleiner is dan de einddatum/startdatum van de cyclus. De gegevens met de juiste datum worden bewaard."
    },
    "next-day": "Volgende dag"
  },
  "wdo-registration-overview": {
    "title": "Overzicht Observatie Registraties",
    "weekly-registrations": "Wekelijkse Observatie Registraties",
    "daily-registrations": "Dagelijkse Observatie Registraties",
    "columns": {
      "weeknr": "Week",
      "date": "Datum"
    },
    "no-observations-found": {
      "title": "Geen observaties gevonden",
      "message": "Er zijn voor deze ronde nog geen wekelijkse of dagelijkse observaties ingevoerd."
    }
  },
  "chicks": "Kuikens",
  "cycles": "Rondes",
  "dashboard": "Dashboard",
  "date": "Datum",
  "date-of-arrival": "Aankomstdatum",
  "day-old-chicks": "Eendagskuikens",
  "days": "Dagen",
  "decontamination": "Reiniging/ ontsmetting",
  "delete": "Verwijderen",
  "delete-item-balance": "Wilt u de balansregel verwijderen?",
  "delete-item-barn-item": "Wilt u de stal verwijderen?",
  "delete-item-day-old-chick": "Wilt u de aanvoer verwijderen?",
  "delete-item-departure": "Wilt u de afvoer verwijderen?",
  "delete-item-flock-cycle": "Wilt u de ronde verwijderen?",
  "delivery": {
    "deliveries": "Leveringen",
    "delivery": "Levering"
  },
  "delivery-item": {
    "amount": "Hoeveelheid per stal",
    "delivery-date": "Leverdatum",
    "error-amount": "Voer de hoeveelheid in",
    "error-delivery-date": "Voer de leverdatum in",
    "error-no-amount": "Geef voor minimaal 1 stal de hoeveelheid op.",
    "error-price": "Voer de netto prijs in",
    "error-product-title": "Voer de productomschrijving in",
    "error-supplier-name": "Voer de naam van de leverancier in",
    "error-units-delivered": "Voer geleverde eenheden in",
    "error-units-delivered-not-enough": "Een deel van deze levering is al gebruikt in de balans van één of meerdere rondes. Het minimum is daarom:",
    "error-vat": "Voer het BTW percentage in",
    "external-product-id": "Artikelnummer",
    "manual-delivery": "Handmatige Levering",
    "price": "Netto prijs, excl. BTW",
    "product-title": "Productomschrijving",
    "product-type-multiple": "Mengvoer",
    "supplier-name": "Leverancier",
    "units-delivered": "Hoeveelheid",
    "vat": "BTW",
    "price-per-100kg": "Netto prijs per 100 kg, excl. BTW",
    "error-price-per-100kg": "Vul de netto prijs per 100 kg in",
    "barn": "Stal",
    "invoice-date": "Factuurdatum",
    "invoice-number": "Factuurnummer",
    "vat-percentage": "BTW-percentage"
  },
  "delivery-overview": {
    "active": "Actief",
    "delivery": "Levering",
    "delivery-lines": "Leveringsregels",
    "display-in-cycle": "Weergeven in ronde",
    "no-deactivation": {
      "description": "Er is een ronde waarin deze levering wordt gebruikt.",
      "title": "Deactivatie niet mogelijk"
    },
    "no-deliveries": {
      "description": "Leveringen worden automatisch toegevoegd en zullen hier worden getoond.",
      "title": "Er zijn geen leveringen voor de geselecteerde periode"
    },
    "remaining-of": "resterend van",
    "remove-delivery-warning": {
      "text": "Dit zal de levering uit deze lijst verwijderen. Leveringen die gebruikt zijn in balansen kunnen niet worden verwijderd.",
      "title": "Weet je zeker dat je deze levering wilt verwijderen?"
    },
    "table": {
      "deliveryDate": "Leverdatum",
      "deliveryId": "Levering ID",
      "product": "Product",
      "isActive": "Actief",
      "showInFinalSetup": "Toon in Financieel Rondeoverzicht",
      "invoiceDate": "Factuurdatum",
      "invoiceNumber": "Factuurnummer"
    }
  },
  "departure": {
    "barn": "Stal",
    "empty-day-old-chicks-description": "Voeg aanvoer toe en deze zal hier worden getoond.",
    "empty-day-old-chicks-title": "Er is nog geen aanvoer",
    "empty-description": "Voeg afvoer toe en deze zal hier worden getoond.",
    "empty-title": "Er is nog geen afvoer"
  },
  "departure-date": "Afvoerdatum",
  "departure-item": {
    "age": "Leeftijd",
    "amount-of-chicks": "Aantal",
    "average-weight": "Gemiddeld gewicht PAK",
    "barn": "Stal",
    "chicks": "kippen",
    "date": "Datum",
    "error-amount-of-chicks-max": "Het maximaal af te voeren kippen is:",
    "error-amount-of-chicks-min": "Voer minimaal 1 kip in",
    "error-amount-of-chicks-required": "Voer het aantal kippen in",
    "error-barn": "Kies een stal",
    "error-date": "Voer de afvoerdatum in. Deze moet na de vroegste aanvoerdatum liggen, maar niet in de toekomst.",
    "error-no-chicks-remaining": "Er zijn geen kippen over om af te voeren",
    "error-type": "Kies een type afvoer",
    "footpad-lesion-score": "Voetzoollaesies score",
    "footpad-lesion-none": "Score 0",
    "footpad-lesion-moderate": "Score 1",
    "footpad-lesion-severe": "Score 2",
    "footpad-lesion-validation": "De percentages in Score 0, 1 en 2 moeten opgeteld precies 100% zijn.",
    "heel-dermatitis": "Hakdermatitis",
    "revenue": "Totale opbrengst (excl. BTW)",
    "slaughter-results": "Slachtresultaten",
    "slaughter-weight": "Totaal uitbetaald gewicht",
    "rejection-at-slaughterhouse": "Afkeur doorberekend",
    "rejection-during-transport": "Afkeur tijdens transport",
    "slaughterhouse": "Slachthuis",
    "type": "Type",
    "type-full": "Wegladers",
    "type-partial": "Uitladers",
    "weight": "Totaal afgeleverd bruto gewicht",
    "weight-validation": "Totaal uitbetaald gewicht mag niet hoger zijn dan totaal afgeleverd gewicht.",
    "diverseCosts": "Diverse kosten",
    "revenueSubTotal": "Opbrengst (excl. BTW)"
  },
  "departure-title": "Afvoer",
  "departure-type-full": "Volledig",
  "departure-type-partial": "Gedeeltelijk",
  "download-pdf": "Download PDF",
  "edit": "Wijzigen",
  "electricity": "Elektriciteit",
  "error-amount-of-chickens": "Voer het aantal kippen in",
  "error-amount-of-chicks": "Voer het aantal eendagskuikens in",
  "error-amount-of-chicks-too-big": "Aantal eendagskuikens is te groot",
  "error-arrival-date": "Voer de aankomstdatum in",
  "error-barn-selected": "Kies een stal",
  "error-breed": "Kies het ras",
  "error-chick-birth-date": "Voer de geboortedatum in",
  "error-chick-price": "Voer de prijs per eendagskuiken in",
  "error-concept": "Kies het concept",
  "error-cycle-number": "Voer een uniek rondenummer in",
  "error-hatchery": "Kies de broederij",
  "error-start-date": "Voer de opzetdatum in",
  "error-surface-area": "Voer de oppervlakte in",
  "error-total-costs": "Voer de totale kosten in",
  "error-total-price": "Voer het bedrag in",
  "feed": "Voeder\n",
  "flocks": "Koppels",
  "general": "Algemeen",
  "grams": "gram",
  "hatchery": "Broederij",
  "healthcare": "Gezondheidszorg",
  "heating": "Verwarming",
  "litter": "Strooisel",
  "management": "Management",
  "manure": "Mestafzet",
  "no-barns-description": "Voeg een stal toe en deze zal hier worden getoond.",
  "no-barns-title": "Er zijn nog geen stallen toegevoegd",
  "no-cycle-selected-description": "Selecteer een ronde om diens informatie te zien.",
  "no-cycle-selected-title": "Er is geen ronde geselecteerd",
  "no-cycles-description": "Voeg een ronde toe en deze zal hier worden getoond.",
  "no-cycles-title": "Er zijn nog geen rondes",
  "no-day-old-chicks-description": "Voeg aanvoer toe en deze zal hier worden getoond.",
  "no-day-old-chicks-title": "Er is nog geen aanvoer",
  "no-departures-description": "Voeg afvoer toe en deze zal hier worden getoond.",
  "no-departures-title": "Er is nog geen afvoer",
  "none": "Geen",
  "nr": "Nr.",
  "number-of-day-old-chicks": "Aantal",
  "other": "Overige",
  "print": "Printen",
  "remove-cycle": "Ronde verwijderen",
  "report-navigation": {
    "barn-report": "Staloverzicht"
  },
  "report-overview": {
    "barn": "stal",
    "barn-report": "Staloverzicht",
    "barn-report-loading": "wordt gemaakt...",
    "cycle": "Ronde",
    "reports": "Rapporten",
    "cycle-closed": "(Ronde afgesloten)"
  },
  "save-as-concept": "Opslaan als draft",
  "settings": "Instellingen",
  "settings-navigation": {
    "barns": "Stallen",
    "observationsetting": "Observaties",
    "rvssetting": "Normkaarten",
    "farmresultsetting": "FarmResult",
    "performance": "Prestaties",
    "finalsetupsetting": "Financieel Rondeoverzicht",
    "discountsetting": "Kortingen",
    "sustainabilitysetting": "Duurzaamheid"
  },
  "observations-setting": {
    "description": "Wilt u uw ronde prestaties bijhouden op wekelijkse en dagelijkse basis?",
    "switch": "Activeer wekelijkse/dagelijkse observaties"
  },
  "column-setting": {
    "title": "Kolom instellingen",
    "description": "Kolommen"
  },
  "rvs-setting": {
    "title": "Normkaarten instellingen",
    "temperatureInside-option": {
      "label": "Temperatuur",
      "Celcius": "Celcius",
      "Fahrenheit": "Fahrenheit",
      "short": {
        "Celcius": "(°C)",
        "Fahrenheit": "(F)"
      }
    },
    "feedIntake-option": {
      "label": "Voer",
      "Gram": "Gram",
      "Kilogram": "Kilogram",
      "short": {
        "Gram": "(g)",
        "Kilogram": "(kg)"
      }
    },
    "waterIntake-option": {
      "label": "Water",
      "ML": "Milliliter",
      "DL": "Deciliter",
      "L": "Liter",
      "short": {
        "ML": "(ml)",
        "DL": "(dl)",
        "L": "(l)"
      }
    },
    "weight-option": {
      "label": "Gewicht",
      "Gram": "Gram",
      "Kilogram": "Kilogram",
      "short": {
        "Gram": "(g)",
        "Kilogram": "(kg)"
      }
    },
    "dayoffset": {
      "title": "Instelling voor de startdag",
      "label": "Startdag"
    }
  },
  "specify-costs": "Specificeer kosten",
  "start-date": "Opzetdatum",
  "title": "PoultryNEXT",
  "title_Agrifirm": "PoultryNEXT",
  "title_Agravis": "Avidata broiler",
  "total-costs": "Totale kosten",
  "total-price": "Bedrag, excl. BTW",
  "unspecified-costs": "Nog te specificeren",
  "water": "Water",
  "water-additives": "Drinkwater toevoegingen",
  "weeks": "weken",
  "search": "Zoeken",
  "dateFrom": "Van",
  "dateTo": "Tot",
  "days-of-week": {
    "Monday": "maandag",
    "Tuesday": "dinsdag",
    "Wednesday": "woensdag",
    "Thursday": "donderdag",
    "Friday": "vrijdag",
    "Saturday": "zaterdag",
    "Sunday": "zondag"
  },
  "unitOfMeasure": {
    "g/day": "g/dag",
    "€/m²/day": "€/m²/dag",
    "$/m²/day": "$/m²/dag",
    "£/m²/day": "£/m²/dag",
    "zł/m²/day": "zł/m²/dag",
    "Ft/m²/day": "Ft/m²/dag"
  },
  "feed-advice": {
    "overview": {
      "title": "Voeradvies overzicht",
      "empty": {
        "title": "Voeradvies data niet beschikbaar",
        "description": "Er is geen voeradvies data beschikbaar op dit moment."
      },
      "table-header": {
        "name": "Naam",
        "created": "Aangemaakt",
        "updated": "Aangepast",
        "updatedAdvisorName": "Aangepast door",
        "isActive": "Actief"
      },
      "buttons": {
        "add": "Voeradvies toevoegen",
        "edit": "Aanpassen",
        "delete": "Verwijderen"
      }
    },
    "create-from-reference": {
      "title": "Voeradvies aanmaken",
      "scratch-title": "Start een nieuw voeradvies",
      "scratch-option-title": "Start een voeradvies",
      "scratch-button": "Start met een leeg advies",
      "scratch-option-subtitle": "Dit is een leeg advies",
      "reference-schemes-title": "Kies een standaard voeradvies als basis",
      "reference-schemes-button": "Start met ",
      "product": "Product",
      "products": "Producten",
      "additive": "Toevoeging",
      "additives": "Toevoegingen"
    },
    "dialog": {
      "deleteConfirm": "Weet u het zeker of u dit voeradvies wilt verwijderen?",
      "deleteConfirmWhenInUse": "Dit voeradvies is gekoppeld aan een ronde, weet u het zeker of u dit voeradvies wilt verwijderen?"
    },
    "create": {
      "print": "Afdrukken",
      "title": "Voeradvies",
      "name": "Voeradvies naam",
      "error-name": "Voeradvies naam is verplicht",
      "description": "Omschrijving",
      "description-placeholder": "Voeradvies omschrijving",
      "product-placeholder": "- selecteer product -",
      "add-product": "Product toevoegen",
      "table-header": {
        "productName": "Product",
        "chickenWeightInGrams": "Kuikengewicht (g)",
        "ageFrom": "Leeftijd van (dgn)",
        "ageTo": "Leeftijd tot (dgn)",
        "totalFeed": "Voeropname (g)",
        "coreFeed": "Kern (g)",
        "wheatFeed": "Tarwe (g)",
        "comment": "Opmerking",
        "age": "Leeftijd (dgn)",
        "coreFeedTons": "Kern (ton)",
        "wheatFeedTons": "Tarwe (ton)",
        "dosage": "Adviesdosering (kg/ton)",
        "applicationMoment": "Leeftijd toepassing"
      },
      "created": "Aangemaakt",
      "updated": "Bijgewerkt",
      "number-of-day-old-chicks": "Aantal kuikens",
      "validation-error": {
        "title": "Validatie fout(en)",
        "feedadvice-name": "Voeradvies naam is verplicht",
        "age-from": "Leeftijd van is verplicht",
        "chicken-weight": "Kuikengewicht is verplicht",
        "product": "Product is verplicht",
        "total-feed": "Voeropname is verplicht",
        "age-to": "Leeftijd tot is verplicht (behalve in de laatste regel)",
        "age-min-max": "Leeftijd Van moet lager zijn dan Leeftijd Tot."
      },
      "products": "Basisadvies",
      "additives": "Toevoegingen",
      "show-additives": "Toon toevoegingen",
      "add-additive": "Toevoeging toevoegen"
    },
    "print": {
      "farmcompany": "Bedrijf",
      "customernr": "Klantnummer",
      "contactperson": "Contactpersoon",
      "location": "Locatie",
      "customerservice": "Klantenservice",
      "table-header": {
        "productName": "Product",
        "chickenWeightInGrams": "Kuikengewicht",
        "age": "Leeftijd",
        "totalFeed": "Voeropname",
        "coreFeed": "Kern",
        "wheatFeed": "Tarwe",
        "comment": "Opmerking",
        "gramPerChick": "Gram/Kuiken",
        "orderQuantity": "Bestelhoeveelheid (ton)",
        "units_gram": "(g)",
        "units_days": "(dgn)",
        "dosage": "Dosering",
        "units_kgton": "kg/ton",
        "applicationMoment": "Leeftijd toepassing"
      }
    }
  },
  "standard-reference-value-sheet": {
    "overview": {
      "title": "Standaard Normkaarten overzicht"
    },
    "create": {
      "title": "Standaard Normkaart"
    }
  },
  "reference-value-sheet": {
    "overview": {
      "title": "Normkaarten overzicht",
      "empty": {
        "title": "Normkaart data niet beschikbaar",
        "description": "Er is geen normkaart data beschikbaar op dit moment."
      },
      "table-header": {
        "name": "Naam",
        "created": "Aangemaakt",
        "updated": "Aangepast",
        "updatedAdvisorName": "Aangepast door",
        "isActive": "Actief"
      },
      "buttons": {
        "add": "Normkaart toevoegen",
        "edit": "Aanpassen",
        "delete": "Verwijderen",
        "copy-as-new": "Kopieer als nieuw",
        "copy-to-other-country": "Kopieer naar ander land"
      },
      "country": "Land"
    },
    "dialog": {
      "deleteConfirm": "Weet u zeker dat u deze normkaart wilt verwijderen?",
      "deleteConfirmWhenInUse": "Deze normkaart is gekoppeld aan een ronde, weet u zeker dat u deze normkaart wilt verwijderen?"
    },
    "create-from-standard": {
      "title": "Normkaart aanmaken",
      "scratch-title": "Start een nieuwe normkaart",
      "scratch-option-title": "Start een normkaart",
      "scratch-button": "Start met een lege normkaart",
      "scratch-option-subtitle": "Dit is een lege normkaart",
      "reference-value-sheet-title": "Kies een standaard normkaart als basis",
      "reference-value-sheet-button": "Start met "
    },
    "create": {
      "print": "Afdrukken",
      "title": "Normkaart",
      "name": "Normkaart naam",
      "error-name": "Normkaart naam is verplicht",
      "add-one-day-values-row": "Dag toevoegen",
      "number-of-days": "Dagen",
      "add-multiple-day-values-rows": "Dagen toevoegen",
      "description": "Omschrijving",
      "description-placeholder": "Normkaart omschrijving",
      "no-day-values-title": "De normkaart is nog leeg",
      "no-day-values-description": "Voeg hieronder dagen toe aan de normkaart om te beginnen.",
      "table-header": {
        "day": "Dag",
        "temperatureInside": "Binnentemperatuur ",
        "relativeHumidity": "Luchtvochtigheid (%)",
        "feedIntake": "Voeropname ",
        "feedIntakePerChickPerDay": "Voeropname ",
        "feedIntakeTotal": "Voeropname Cum ",
        "feedIntakePerChickTotal": "Voeropname Cum ",
        "waterIntake": "Water ",
        "weight": "Gewicht ",
        "mortality": "Uitval (%)",
        "feedConversion": "Voerconversie Cum",
        "waterToFeedRatio": "Water:voer Cum"
      },
      "created": "Aangemaakt",
      "updated": "Bijgewerkt",
      "validation-error": {
        "title": "Validatie fout(en)",
        "refvalsheet-name": "Normkaart naam is verplicht"
      }
    },
    "print": {
      "farmcompany": "Bedrijf",
      "customernr": "Klantnummer",
      "contactperson": "Contactpersoon",
      "location": "Locatie"
    },
    "select-country": {
      "title": "Selecteer het land",
      "description": "Selecteer het land waar je het naar toe wilt kopiëren",
      "label": "Land"
    }
  },
  "reference-scheme": {
    "overview": {
      "title": "Standaard voeradviezen overzicht",
      "empty": {
        "title": "Standaard voeradvies data niet beschikbaar",
        "description": "Er is geen standaard voeradvies data beschikbaar op dit moment."
      },
      "table-header": {
        "name": "Naam",
        "created": "Aangemaakt",
        "updated": "Aangepast",
        "updatedAdvisorName": "Aangepast door",
        "isActive": "Actief"
      },
      "buttons": {
        "add": "Standaard voeradvies toevoegen",
        "edit": "Aanpassen",
        "delete": "Verwijderen"
      },
      "country": "Land"
    },
    "dialog": {
      "deleteConfirm": "Weet u zeker dat u dit standaard voeradvies wilt verwijderen?"
    },
    "create": {
      "title": "Standaard voeradvies",
      "name": "Standaard voeradvies naam",
      "error-name": "Standaard voeradvies naam is verplicht",
      "description": "Omschrijving",
      "description-placeholder": "Standaard voeradvies omschrijving",
      "product-placeholder": "- selecteer product -",
      "add-product": "Product toevoegen",
      "table-header": {
        "productName": "Product",
        "chickenWeightInGrams": "Kuikengewicht (g)",
        "ageFrom": "Leeftijd van (dgn)",
        "ageTo": "Leeftijd tot (dgn)",
        "totalFeed": "Voeropname (g)",
        "coreFeed": "Kern (g)",
        "wheatFeed": "Tarwe (g)",
        "comment": "Opmerking"
      },
      "created": "Aangemaakt",
      "updated": "Bijgewerkt"
    }
  },
  "product-title": "Producten",
  "product-save": "Producten opslaan",
  "product-saved": "Product opgeslagen!",
  "product-overview": {
    "title": "Producten overzicht",
    "overview": {
      "productName": "Naam",
      "productCode": "Product code",
      "phase": "Voerfasen",
      "isActive": "Actief",
      "productType-Feed": "Voer",
      "productType-Additive": "Toevoeging",
      "productType": "Producttype"
    },
    "no-products": {
      "title": "Geen producten gevonden",
      "description": "Klik op Toevoegen om een product aan te maken."
    },
    "delete-confirmation-title": "Product verwijderen",
    "delete-confirmation-message": "Weet je zeker dat je dit product wilt verwijderen?",
    "delete-error-message": "Het product kon niet worden verwijderd. Zorg ervoor dat deze niet in een referentieschema is opgenomen.",
    "delete-error-in-use-message": "Dit product kan niet worden verwijderd, omdat het wordt gebruikt in één of meerdere voeradviezen.",
    "country": "Land",
    "delete-confirmation-message-when-in-use": "Dit product wordt gebruik in een of meerdere voeradviezen, weet u zeker dat u dit product wilt verwijderen?"
  },
  "create-product": {
    "title-create": "Product toevoegen",
    "title-edit": "Product aanpassen:",
    "product-name": "Productnaam",
    "phases-label": "Voerfasen",
    "product-code": "Productcode",
    "error-product-name": "Vul de naam in van het product.",
    "error-product-code": "Vul de productcode in van het product.",
    "error-code-name-already-in-use": "Gebruik een unieke combinatie van naam en code",
    "product-type": {
      "label": "Producttype",
      "Feed": "Voer",
      "Additive": "Toevoeging"
    },
    "error-product-type": "Producttype is verplicht."
  },
  "countries": {
    "BE": "België",
    "DE": "Duitsland",
    "HU": "Hongarije",
    "NL": "Nederland",
    "PL": "Polen",
    "JO": "Jordanië",
    "NG": "Nigeria",
    "JM": "Jamaica",
    "TZ": "Tanzania",
    "DA": "Duitsland-Agravis"
  },
  "save": "Opslaan",
  "report-title": "Staloverzicht vleeskuikens",
  "report-name": "Koppel-rapport-",
  "report-headers": {
    "general": "Algemeen",
    "day-old-chicks": "Aanvoer kuikens",
    "total": "Totaal",
    "departures": "Afvoer kuikens",
    "balance": "Voeroverzicht",
    "key-figures": "Kengetallen",
    "technical": "Technisch",
    "financial": "Financieel"
  },
  "report-columns": {
    "customer": "Klant",
    "location": "Locatie",
    "barn": "Stal",
    "breed": "Ras",
    "concept": "Concept",
    "start-date": "Opzetdatum",
    "date": "Datum",
    "age": "Leeftijd [dagen]",
    "amount": "Aantal",
    "price": "Bedrag (excl. BTW)",
    "discount": "Korting (excl. BTW)",
    "delivered": "Afgeleverd [kg]",
    "weight": "Gewicht [g]",
    "paid": "Uitbetaald [kg]",
    "rejected": "Afkeur [%]",
    "feed-code": "Voercode",
    "feed-name": "Voernaam",
    "consumption": "Verbruik [kg]",
    "consumption-per-day-old-chick": "Verbruik POK [g]",
    "day-old-chicks": "Opzet aantal (m²)",
    "drop-out-total": "Uitval totaal(%)",
    "avg-age": "Gem. leeftijd (dgn)",
    "avg-weight": "Gem. gewicht (g)",
    "deliveredkg-per-m2": "Geleverde kg per m²",
    "growth": "Groei (g/d)",
    "feed-conversion": "Voerconversie",
    "feed-conversion-1500": "Voerconversie 1500",
    "replacement": "Vervanging (%)",
    "avg-rejected": "Afkeur doorberekend (%)",
    "production-number": "Productiegetal",
    "price-per-delivered-chick": "Prijs per eendagskuiken POK (ct)",
    "feed-price-per-100": "Voerprijs per 100kg",
    "feed-price-per-delivered-kg": "Voerkosten per afgeleverde kg (ct)",
    "yield-per-kg": "Opbrengsten per kg",
    "feed-profit": "Voerwinst",
    "feed-profit-per-day-old-chick": "Voerwinst pak (ct)",
    "feed-profit-per-m2-per-day": "Voerwinst per m² per dag (ct)",
    "cycle-nr": "RondeNr",
    "barns": "Stallen",
    "netto-profit-incl-other-costs": "Saldo",
    "discountLabel-ledenvoordeel": "Ledenvoordeel",
    "discountLabel-ledenkorting": "Ledenkorting",
    "discountLabel-integratiepremie": "Integratiepremie",
    "discountLabel-nieuwbouwpremie": "Nieuwbouwpremie",
    "discountLabel-ncw": "NCW (Netto contante waarde uitkering)",
    "total-incl-discount": "Totaal (incl. premies)",
    "discountLabel-korting": "Korting",
    "discountLabel-overig": "Overig",
    "discountLabel-nabetaling": "Nabetaling",
    "discountLabel-correctievoerprijs": "Correctie voerprijs",
    "discountLabel-vergoedingvolgensafspraak": "Vergoeding volgens afspraak",
    "feed-profit-per-m2": "Voerwinst per m²"
  },
  "total": "Totaal",
  "days-short": "Dgn",
  "parent-stock-identifier": "VB-nummer",
  "import": "Importeren",
  "csv-import": {
    "delivery-success": "Leveringen succesvol geimporteerd.",
    "departure-success": "Afvoer succesvol geimporteerd.",
    "errors": {
      "amount-exceeds-remaining": "Rij ${rowNumber}: Het aantal is groter dan het resterende aantal kuikens voor stal '${barn}'. Het maximaal toegestane aantal is ${maxAmount}.",
      "barn-not-found": "Rij ${rowNumber}: Stal '${value}' is niet gevonden in de geselecteerde ronde.",
      "configured-slaughterhouses-could-not-be-loaded": "Geconfigureerde slachterijen konden niet worden geladen.",
      "cycle-could-not-be-loaded": "Ronde '${cycleId}' kon niet worden geladen.",
      "cycle-invalid": "CSV-afvoer is ongeldig voor de geselecteerde ronde.",
      "cycle-not-found": "Ronde '${cycleId}' is niet gevonden voor de huidige klant/locatie.",
      "date-before-first-arrival": "Rij ${rowNumber}: Datum moet op of na de eerste aanvoerdatum liggen.",
      "date-in-future": "Rij ${rowNumber}: Datum mag niet in de toekomst liggen.",
      "duplicate-column": "CSV bevat dubbele kolom '${column}'.",
      "file-empty": "CSV-bestand is leeg.",
      "file-required": "CSV-bestand is verplicht.",
      "file-too-large": "CSV-bestand is te groot. De maximaal toegestane grootte is ${maxSizeKb} KB.",
      "invalid-date": "Rij ${rowNumber}: ${field} is verplicht en moet een geldige datum zijn.",
      "invalid-number": "Rij ${rowNumber}: ${field} moet een geldig getal zijn.",
      "missing-required-columns": "CSV mist verplichte kolom(men): ${columns}.",
      "no-data-rows": "CSV moet minimaal één gegevensrij bevatten.",
      "required-field": "Rij ${rowNumber}: ${field} is verplicht.",
      "required-positive-whole-number": "Rij ${rowNumber}: ${field} is verplicht en moet een positief geheel getal zijn.",
      "required-valid-number": "Rij ${rowNumber}: ${field} is verplicht en moet een geldig getal zijn.",
      "skip-import-invalid": "Rij ${rowNumber}: Import overslaan moet leeg zijn of een van de volgende waarden bevatten: yes, no, true, false, 1, 0, x.",
      "slaughterhouse-not-found": "Rij ${rowNumber}: Slachterij '${value}' is niet gevonden.",
      "too-many-rows": "CSV bevat te veel rijen. Het maximaal toegestane aantal rijen is ${maxRows}.",
      "total-slaughterweight-higher-than-departure-weight": "Rij ${rowNumber}: Totaal slachtgewicht mag niet hoger zijn dan het afvoergewicht.",
      "type-invalid": "Rij ${rowNumber}: Type is verplicht en moet Volledig of Gedeeltelijk zijn.",
      "unterminated-quote": "CSV bevat een waarde met een openingsaanhalingsteken zonder sluitend aanhalingsteken.",
      "unknown": "CSV-import is mislukt.",
      "unsupported-file-type": "Alleen CSV-bestanden worden ondersteund."
    },
    "download-template": "Sjabloon downloaden",
    "invalid-file": "Selecteer een geldig CSV-bestand.",
    "upload": "CSV uploaden"
  },
  "slaughter-report": "Slachtrapport",
  "link-slaughter-results-title": "Slachtresultaten koppelen",
  "link-slaughter-results-description": "Selecteer per slachtrapport een stal. Per slachtrapport wordt er vervolgens één afvoerregel aangemaakt.",
  "slaughter-date": "Slachtdatum",
  "number-of-chickens": "Aantal kippen",
  "departure-weight-kg": "Afvoergewicht (kg)",
  "show-financial-data": "Toon financiële data",
  "financial-results": "Financiële resultaten",
  "link-to-barn": "Koppelen aan stal",
  "imported-slaughter-report-label": "Geïmporteerd slachtrapport",
  "slaughter-weight-kg": "Slachtgewicht (kg)",
  "veterinary": "Veterinair",
  "employment": "Arbeid",
  "otherRevenue": "Overige inkomsten",
  "otherCosts": "Overige kosten",
  "discount-title": "Kortingen",
  "discount-label": "Korting label",
  "discount-applicabilityType": "Geldt voor",
  "discount-amount": "Bedrag, excl. BTW",
  "discount-item": {
    "applicabilityType-arrivalcost": "Aankomstkosten",
    "applicabilityType-feedcost": "Voerkosten",
    "applicabilityType-departurerevenue": "Afvoeropbrengst",
    "add-discount": "Korting toevoegen",
    "labelType-ledenvoordeel": "Ledenvoordeel",
    "labelType-ledenkorting": "Ledenkorting",
    "labelType-integratiepremie": "Integratiepremie",
    "labelType-nieuwbouwpremie": "Nieuwbouwpremie",
    "labelType-ncw": "Netto contante waarde uitkering",
    "labelType-korting": "Korting",
    "labelType-overig": "Overig",
    "labelType-nabetaling": "Nabetaling",
    "labelType-correctievoerprijs": "Correctie voerprijs",
    "labelType-vergoedingvolgensafspraak": "Vergoeding volgens afspraak"
  },
  "discount": {
    "no-discounts-title": "Er zijn nog geen kortingen.",
    "no-discounts-description": "Voeg een korting toe en deze zal hier worden getoond."
  },
  "delete-item-discount": "Wilt u de korting verwijderen?",
  "farm-result": {
    "table-header": {
      "sensorActuator": "Sensor/Actuator Id",
      "barn": "Stal",
      "sensorActuatorName": "Sensor/Actuator Naam",
      "farmResultLocationId": "Locatie Id"
    },
    "select-barn-placeholder": "- selecteer een stal -"
  },
  "discountLabel-korting": "Korting",
  "discountLabel-overig": "Overig",
  "discountLabel-nabetaling": "Nabetaling",
  "discountLabel-correctievoerprijs": "Correctie voerprijs",
  "discountLabel-vergoedingvolgensafspraak": "Vergoeding volgens afspraak",
  "delete-item-day-old-chick-used-in-balance": "Deze aanvoer wordt gebruikt op de balans. Als u deze aanvoer toch verwijdert, moet de balans herberekend worden. Wilt u de aanvoer verwijderen?",
  "edit-day-old-chick_barn-used-in-balance": "U wijzigt een stal die wordt gebruikt op de balans. Als u deze wijziging toch doorvoert, moet de balans herberekend worden. Wilt u doorgaan?",
  "cycle-description": "Omschrijving",
  "confirm": "Bevestigen",
  "interval-type-Day": "Dag",
  "interval-type-Week": "Week",
  "unitOfMeasure-setting": {
    "title": "Maateenheid",
    "warning": "Het wijzigen van de maateenheid-instellingen kan resulteren in kleine waardeverschillen die worden veroorzaakt door wiskundige afrondingen.",
    "waterIntakeUnit": "Waterinlaateenheid",
    "CumulativeLiter": "Totaal L",
    "MililiterPerBird": "Ml per dier",
    "feedIntakeUnit": "Voeropname-eenheid",
    "CumulativeKilogram": "Totaal Kg",
    "GramPerBird": "Gram per dier"
  },
  "error-amount-of-chicks-minimum": "Het minimum aantal kuikens is:",
  "animal-group": {
    "animalGroupTitle": "Animal Group",
    "switchDay": "Wisseldag",
    "addSwitchDay": "Schakeldag toevoegen",
    "phaseFrom": "Fase vanaf",
    "phaseTo": "Fase naar",
    "date": "Datum",
    "medication": "Medicatie",
    "treatmentDateStart": "Behandeling starten",
    "treatmentDateEnd": "Einde behandeling",
    "addMedication": "Medicatie toevoegen",
    "diagnose": "Diagnostiseren",
    "quantity": "Hoeveelheid",
    "unit": "Eenheid",
    "quantityUnitDescriptions": {
      "kilogram": "Kilogrammen",
      "gramsPerLitre": "Gram per liter",
      "percentage": "Percentage",
      "gram": "Grammen",
      "noUnit": "Geen eenheid",
      "gramsPerKilogram": "Gram per kilogram",
      "milligram": "Milligrammen",
      "milligramsPerKilogram": "Milligram per kilogram"
    },
    "vaccination": "Vaccinatie",
    "addVaccination": "Vaccinatie toevoegen",
    "vaccine": "Vaccin",
    "poultryDisease": "Ziekte van pluimvee",
    "vaccinationMethod": "Vaccinatie Methode",
    "validationDialogTitle": "Benodigde informatie",
    "validationDialogMessage": "Voeg de vereiste informatie in de tabellen toe",
    "veterinarianTitle": "Dierenarts"
  },
  "final-setup-setting": {
    "switch": "Financieel Rondeoverzicht",
    "chick-delivery-switch": "Leveringen Kuikens",
    "feed-delivery-switch": "Leveringen Voer",
    "departure-switch": "Afvoer",
    "discount-switch": "Kortingen",
    "title": "Financieel Rondeoverzicht",
    "default-settings-title": "Standaard Instellingen",
    "masterdata": {
      "title": "Stamgegevens",
      "notes": "Opmerkingen",
      "payer": "Betaler",
      "payer-email": "E-mailadres van de betaler",
      "representative-agrifirm": "Vertegenwoordiger <Tenant>",
      "separate-stable": "Aparte stal",
      "integration-premium": "Integratiepremie",
      "discount-value": "waarde van korting",
      "agrifirm-member": "<Tenant>-lid"
    }
  },
  "invoice-date": "Factuurdatum",
  "invoice-number": "Factuurnummer",
  "vat-percentage": "BTW-percentage",
  "vat": "BTW (%)",
  "amount-including-vat": "Bedrag inclusief BTW (€)",
  "final-setup": {
    "chick-deliveries": "Leveringen Kuikens",
    "empty-chick-deliveries-title": "Geen kuiken leveringen",
    "empty-chick-deliveries-description": "Geen kuiken leveringen",
    "day-old-chick": "Eendagskuikens",
    "feed-deliveries": "Leveringen Voer",
    "empty-feed-deliveries-title": "Geen voer leveringen",
    "empty-feed-deliveries-description": "Geen voer leveringen",
    "empty-departures-description": "Geen afvoer",
    "departures": "Afvoer",
    "empty-departures-title": "Geen afvoer",
    "discounts": "Kortingen",
    "empty-discounts-title": "Geen kortingen",
    "empty-discounts-description": "Geen kortingen",
    "print-footer": "Op alle door ons aangegane overeenkomsten en geleverde producten en/of diensten zijn uitsluitend de Algemene Leveringsvoorwaarden van Agrifirm NWE BV van toepassing, deze worden op eerste verzoek kosteloos aan u toegestuurd en zijn tevens te raadplegen en op te slaan via: https://www.agrifirm.nl/globalassets/agrifirm-group/agrifirm-nl/leveringsvoorwaarden/general-terms--nl.pdf​",
    "print-footer-agravis": "Op alle door ons aangegane overeenkomsten en geleverde producten en/of diensten zijn uitsluitend de Algemene Leveringsvoorwaarden van Agravis van toepassing, deze worden op eerste verzoek kosteloos aan u toegestuurd.",
    "print-description": "Omschrijving",
    "print-message-line-1": "Geachte heer, mevrouw,",
    "print-message-line-2": "Hierbij sturen wij u een overzicht van de facturen over de afgelopen ronde.",
    "print-end-line-1": "Bovenstaand overzicht moet overeenstemmen met uw administratie.",
    "print-end-line-2": "Met vriendelijke groeten,",
    "print-company-name": "Agrifirm NWE BV",
    "print-company-name-agravis": "Agravis",
    "print-company-email": "E-mailadres: kengetallenadministratie@agrifirm.com",
    "print-company-email-agravis": "E-mailadres: info@agravis.nl",
    "print-company-phone": "Telefoonnummer: 088 - 488 2976",
    "print-company-phone-agravis": "",
    "print-to-receive": "Door u te ontvangen",
    "print-total-feed": "Totaal voer, voor specificatie zie bijlage",
    "print-invoice-number": "Factuurno.",
    "print-amount-excluding-vat": "Bedrag excl.",
    "print-vat-amount": "Bedrag BTW",
    "print-amount-including-vat": "Bedrag incl.",
    "print-product": "Artikel",
    "print-net-weight": "Netto (kg)",
    "include-in-calculations-label": "Meenemen in berekening",
    "print-to-pay": "Door u te betalen",
    "print-payment-terms": "Wij verzoeken u vriendelijk bovenstaand bedrag binnen 14 dagen, onder vermelding van uw klantnummer, te betalen op bankrekening NL.86.RABO.010.10.50.003.",
    "print-subtotal": "Subtotaal",
    "feed-delivery-end-date": "Eindopstelling ronde einddatum",
    "additional-invoices": "Overige facturen (Exlan etc.)",
    "empty-additional-invoices-title": "Geen overige facturen",
    "empty-additional-invoices-description": "Geen overige facturen",
    "additional-invoices-add": "Toevoegen",
    "additional-invoices-delete-confirm-title": "Verwijder factuur",
    "additional-invoices-delete-confirm-description": "Weet u zeker dat u deze factuur wilt verwijderen?",
    "fixed-price": "Vaste prijsafspraak",
    "fixed-price-per-100": "Prijs per 100 kg",
    "fixed-price-correction": "Prijscorrectie volgens afspraak",
    "price-agreement": "prijsafspraak",
    "per-100-kg": "/ 100 kg excl. Btw."
  },
  "amount-excluding-vat": "Bedrag, excl. BTW (€)",
  "discount-description": "Omschrijving",
  "discount-showInFinalSetup": "Toon in Financieel Rondeoverzicht",
  "label": "Label",
  "link-slaughter-invoices-description": "Selecteer de facturen die gekoppeld moeten worden aan de ronde. Per factuur komt er één regel in het rondeoverzicht.",
  "link-slaughter-invoices-title": "Slachtfacturen koppelen",
  "slaughter-invoice": "Slachtfactuur",
  "vaccination-price": "Netto prijs per enting, excl. BTW",
  "discount-price": "Netto korting per kuiken, excl. BTW",
  "diverse-price": "Diversen per kuiken, excl. BTW",
  "total-price-including-vat": "Bedrag, incl. BTW",
  "total-calculated-amount": "Totaalbedrag, excl. BTW",
  "total-calculated-amount-including-vat": "Totaalbedrag, incl. BTW",
  "arrival-notification-cycle-overview": "Netto prijs en Netto korting gaan mee in het technisch ronde overzicht en in het financieel ronde overzicht",
  "arrival-notification-final-setup": "Netto prijs per enting en diversen per kuiken gaan mee in het financieel overzicht, daar is het totaal terug te vinden",
  "edit-day-old-chick": "Wijzigen Aanvoer",
  "edit-departure": "Wijzigen Afvoer",
  "of-delivery": "van Aanvoer",
  "delivery-date": "Leverdatum",
  "delivery-number": "Levering ID",
  "base-quantity": "Hoeveelheid (kg)",
  "discount-setting": {
    "title": "Kortingen",
    "memberDiscountNL": "Ledenkorting (€)",
    "memberBenefitNL": "Ledenvoordeel (%)",
    "memberBenefitAbroad": "Ledenvoordeel buitenland (%)",
    "warning-title": "Let op!",
    "warning-message": "Deze waarden worden gebruikt voor alle klanten en locaties. Pas deze dus niet zomaar aan."
  },
  "sustainability": {
    "calculations": {
      "source": "Bron",
      "value": "Waarde",
      "unit": "Eenheid",
      "description": "Bekijk eerdere berekeningen of bereken een andere ronde.",
      "new": "Nieuwe berekening",
      "result": "Opgeslagen resultaat",
      "history": "Eerdere berekeningen",
      "last-updated": "Laatst bijgewerkt",
      "history-description": "Selecteer een berekening om het resultaat te bekijken.",
      "calculation": "Berekening",
      "view-result": "Bekijk resultaat",
      "empty": "Er zijn nog geen berekeningen opgeslagen voor deze ronde.",
      "select-cycle": "Selecteer een ronde om de opgeslagen berekeningen te bekijken.",
      "loading": "Berekeningen laden…",
      "load-error": "De berekeningen konden niet worden geladen. Probeer opnieuw.",
      "retry": "Opnieuw proberen",
      "pending": "Deze berekening wordt nog verwerkt. Vernieuw het resultaat later.",
      "calculating": "Voer importeren en de CO₂-voetafdruk berekenen…",
      "result-failed": "Deze berekening is mislukt. Controleer de vereisten in het berekeningspaneel en probeer opnieuw. Blijft dit gebeuren, neem dan contact op met uw adviseur.",
      "attempt-failed": "De laatste poging is mislukt. Controleer de vereisten hieronder en probeer opnieuw. Eerder opgeslagen resultaten blijven beschikbaar.",
      "status": {
        "complete": "Berekend",
        "pending": "In verwerking",
        "failed": "Mislukt"
      }
    },
    "readiness": {
      "view-details": "Bekijk voergegevens",
      "requirements-met": "vereisten voldaan",
      "title": "Vereisten",
      "checking": "Benodigde gegevens controleren…",
      "error": "De benodigde gegevens konden niet worden gecontroleerd. Probeer opnieuw.",
      "ready": "Benodigde gegevens compleet.",
      "blocked": "Vul onderstaande gegevens aan voordat u de berekening start.",
      "complete": "Compleet",
      "action-required": "Actie nodig",
      "edit-arrivals": "Opzet aanpassen",
      "edit-departures": "Afleveringen aanpassen",
      "edit-resources": "Energie per jaar aanpassen",
      "edit-bedding": "Strooisel aanpassen",
      "advisor": "Neem contact op met uw adviseur om deze gegevens te corrigeren. Deel de product- en leveringsgegevens hierboven.",
      "disclaimer": "Deze controle kijkt of de benodigde gegevens compleet zijn. Sustell kan de berekening nog afwijzen.",
      "recheck": "Opnieuw controleren",
      "calculation-failed": "Sustell kon deze CO₂-voetafdruk niet berekenen. Controleer de voorwaarden hieronder en probeer opnieuw. Blijft dit gebeuren, neem dan contact op met uw adviseur.",
      "requirements": {
        "cycle": "Opzet, afleveringen en geldige datums",
        "farm-resources": "Energie voor elk benodigd jaar",
        "bedding": "Strooiselgegevens",
        "feeds": "Voedingswaarden en emissies van voer"
      },
      "arrival-weight": "Gemiddeld opzetgewicht per kuiken",
      "departure-weight": "Gemiddeld aflevergewicht per kuiken",
      "issues": {
        "feeds-missing": "Registreer krachtvoerverbruik in de voerbalans van deze ronde.",
        "arrivals-missing": "Registreer de opzet van kuikens.",
        "departures-missing": "Registreer de afleveringen.",
        "cycle-dates-invalid": "Corrigeer de ronde-, opzet- en afleverdatums.",
        "arrival-data-invalid": "Vul een positief aantal kuikens en opzetgewicht in gram per kuiken in.",
        "departure-data-invalid": "Vul een positief aantal kuikens en totaal aflevergewicht in kg in.",
        "departure-weight-below-arrival": "Het gemiddelde aflevergewicht moet minstens gelijk zijn aan het gemiddelde opzetgewicht. Controleer het opzetgewicht in gram per kuiken, het totale aflevergewicht in kg en de aantallen kuikens.",
        "farm-resources-missing": "Registreer het energieverbruik voor jaar",
        "cycle-dates-required": "Registreer geldige opzet en afleveringen om de benodigde jaren te controleren.",
        "bedding-type-missing": "Selecteer het strooiseltype.",
        "bedding-amount-missing": "Vul de hoeveelheid strooisel in.",
        "ship-to-missing": "De leverlocatie is niet gekoppeld aan de voerleverancier.",
        "delivery-missing": "De leveringsgegevens ontbreken.",
        "delivery-line-missing": "De gegevens van het geleverde product ontbreken.",
        "feed-data-invalid": "Benodigde voergegevens ontbreken of zijn ongeldig.",
        "feed-settings-missing": "De instellingen voor voerimport zijn niet compleet.",
        "farm-resources-not-calculated": "Sla de energiegegevens opnieuw op om het verbruik aan deze ronde toe te wijzen."
      },
      "fields": {
        "Consumption": "Voerverbruik (kg), groter dan nul",
        "Co2Total": "Totale CO₂-voetafdruk",
        "Co2TotalMismatch": "Het CO₂-totaal komt niet overeen met de som van biogene, fossiele en landgebruiksveranderingsemissies. Vraag je adviseur om de voergegevens te corrigeren.",
        "Biogenic": "Biogene emissies",
        "FossilExcludingPeatEmissions": "Fossiele emissies zonder veen",
        "FossilPeatEmissions": "Veenemissies",
        "LandUseChange": "Emissies door verandering in landgebruik",
        "DryMatterAmount": "Drogestofgehalte",
        "RoughProtein": "Eiwitgehalte",
        "ProductIdentifier": "Productnummer"
      },
      "edit-feeds": "Voerbalans aanpassen",
      "edit-cycle": "Ronde aanpassen"
    },
    "sustainability": "Duurzaamheid",
    "farm-resources": "Energie per jaar",
    "carbon-footprint": "CO2 Voetafdruk",
    "add-farm-resources": "Voeg energiebronnen toe",
    "confirm-delete-farm-resource": "De boerderijbron verwijderen?",
    "farm-resource-deleted": "Boerderijbron verwijderd",
    "farm-resource-saved": "Boerderijbron opgeslagen",
    "year": "Jaar",
    "farm-settings-saved": "Boerderij-instellingen opgeslagen",
    "farm-settings-enable-co2-calculation": "CO2-berekeningen inschakelen voor deze boerderij",
    "resource": {
      "electricity": "Elektriciteit (kWh)",
      "electricity-photovoltaic": "Elektriciteit Zon (kWh)",
      "electricity-wind": "Elektriciteit Wind (kWh)",
      "natural-gas": "Aardgas (m³)",
      "diesel": "Diesel (L)",
      "gasoline": "Benzine (L)",
      "coal": "Steenkool (KG)",
      "propane-lpg": "Propaan / LPG (L)",
      "water": "Water (m³)",
      "cycle-start-date": "Startdatum",
      "cycle-end-date": "Einddatum",
      "status": "Status",
      "statuses": {
        "complete": "Afgesloten",
        "partial": "Onvolledig"
      },
      "water-error": "Water moet een positief getal zijn",
      "electricity-error": "Elektriciteit moet een positief getal zijn",
      "electricity-photovoltaic-error": "Elektriciteit Zon moet een positief getal zijn",
      "electricity-wind-error": "Elektriciteit Wind moet een positief getal zijn",
      "natural-gas-error": "Aardgas moet een positief getal zijn",
      "diesel-error": "Diesel moet een positief getal zijn",
      "gasoline-error": "Benzine moet een positief getal zijn",
      "propane-lpg-error": "Propaan/LPG moet een positief getal zijn",
      "coal-error": "Steenkool moet een positief getal zijn"
    },
    "farm-resources-title": "Energieverbruik per jaar",
    "cycle-resources": "Energieverbruik per ronde",
    "value": "Waarde levend gewicht (kg CO2eq / kg lichaamsgewicht)",
    "notification-title": "Belangrijke informatie over CO2 berekeningen",
    "notification-description": "De berekening van de carbon footprint wordt uitgevoerd door de LCA software Sustell. Aan de basis ligt de CO2 op voer zoals uitgevoerd conform de actuele Nevedi instructie. Om een correctie berekening te kunnen uitvoeren moeten alle gegevens volledig zijn ingevoerd: <b>technische prestaties van volledig koppel incl. productie en afvoer/slacht en energieverbruik.</b>\nWeergegeven waarden kunnen onderhevig zijn aan veranderingen door aanpassing van de klimaatwetenschap en de daaruit volgende wijzigingen in de berekenings-systematiek, evenals wijzigingen in wet- en regelgeving en eventueel van toepassing zijnde standaarden. Hoewel de hier getoonde informatie zorgvuldig is samengesteld kunnen hieraan geen rechten ontleend worden.",
    "action-text-close": "Verbergen",
    "action-text-open": "Toon",
    "farm-resources-not-complete": "Cyclusbronnen zijn niet compleet.",
    "bedding-type-required": "Beddengoed is vereist voor de cyclus.",
    "bedding-amount-required": "De hoeveelheid beddengoed is nodig voor de cyclus.",
    "start-calculation": "Start met het berekenen van CO2",
    "refresh-carbon-footprint": "Ververs CO2 voetafdruk",
    "carbon-footprint-title-error": "Fout bij berekening van CO2 voetafdruk",
    "carbon-footprint-title": "Berekening van de CO2 voetafdruk",
    "carbon-footprint-text": "De berekening van de CO2 voetafdruk zal starten. Even geduld alstublieft terwijl het proces wordt voltooid (ongeveer 1 minuut).",
    "carbon-footprint-refresh-error-title": "CO2-voetafdruk kon niet worden vernieuwd",
    "carbon-footprint-refresh-error-text": "We konden de CO2-voetafdruk niet vernieuwen. Probeer het over enkele ogenblikken opnieuw."
  },
  "bedding-type": "Strooisel",
  "bedding-types": {
    "NoBedding": "Geen strooisel",
    "BarleyStraw": "Gerst stro",
    "MaizeStover": "Maïsloof",
    "OatStraw": "Haver stro",
    "SawDust": "Zaagsel",
    "SunflowerHusk": "Zonnebloemschillen",
    "WheatStraw": "Tarwestro",
    "Woodshavings": "Houtkrullen"
  },
  "bedding-amount": "Hoeveelheid strooisel",
  "bedding-amount-error": "Hoeveelheid strooisel moet een positief getal zijn",
  "transport-distance": "Transport vanaf de broederij",
  "transport-distance-error": "Het transport vanaf opfokker moet een getal zijn tussen 0 en 1000",
  "time-in-free-range": "Tijd in vrije uitloop",
  "time-in-free-range-error": "Tijd in vrije uitloop moet een getal zijn tussen 0 en 100",
  "general-settings-error": "Er is een fout opgetreden bij het ophalen van de instellingen voor PoultryNEXT.",
  "tenants": {
    "Agrifirm": "agrifirm",
    "Agravis": "agravis"
  }
}
